import React from "react";
import { Breadcrumb, Flex } from "antd";
import { CheckOutlined } from "@ant-design/icons";
import { MainLayout } from "components/layouts";
import { useTranslation } from "react-i18next";

const AdminCompanyPackageDetail = () => {
  const { t } = useTranslation();

  const Mockdata = [
    "บันทึกข้อมูลพนักงาน",
    "คำนวณเงินเดือน",
    "ประกันสังคมและภาษี",
    "เครื่องมือช่วยอื่น ๆ",
    "กำหนดสิทธิการเข้าถึง",
    "ยื่นคำขอและอนุมัติเอกสาร",
    "ลายเซ็นต์อิเล็กทรอนิกส์",
    "โยกย้าย/แต่งตั้งภายใน",
    "กำหนดผู้อนุมัติเอกสารได้",
    "ยื่นคำขอและอนุมัติเอกสารได้สูงสุด 2 ชั้น",
    "เช็คข้อมูลปฏิทินการทำงานและภาระงานของทีม",
    "กำหนดบทบาทและโครงสร้างองค์กรสูงสุด 5 ชั้น",
    "Widget Dashboard",
    "ใช้งานร่วมกับระบบเวลา SMART",
  ];

  return (
    <MainLayout>
      <Flex vertical gap={24}>
        <Flex vertical>
          <Breadcrumb
            items={[
              { title: t("configuration.header"), href: "/admin/response_company" },
              { title: t("response_company.header"), href: "/admin/response_company" },
              { title: t("response_company.label.package_detail") },
            ]}
          />
          <Flex gap={8}>
            <h2>{t('Package_information.Your_package')}</h2>
            <h2 style={{ color: "#2CADE7" }}>Pro</h2>
          </Flex>
          <span style={{ color: "#667085" }}>{`${t('Package_information.Your_package_expires_on')} 11 ตุลาคม 2569`}</span>
        </Flex>

        <Flex vertical gap={24} style={{ marginTop: "26px" }}>
          <span style={{ fontSize: "20px" }} > {t('Package_information.package_detail_features')}</span>

          <Flex vertical gap={16} style={{ paddingLeft: "16px" }}>
            {Mockdata.map((item, index) => (
              <Flex key={index} align="start" gap={12} style={{ alignItems: "center" }}>
                <CheckOutlined style={{ color: "#0070f3" }} />
                <span style={{ color: "#555555", fontSize: "16px" }}>{item}</span>
              </Flex>
            ))}
          </Flex>
        </Flex>
      </Flex>
    </MainLayout>
  );
};

export default AdminCompanyPackageDetail;



